import React from "react";
import { Box } from "@mui/material";

const CenteredLoader: React.FC = () => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
      }}
    >
      <img
        src="/images/foyr-logo.svg"
        alt="Loading"
        className="foyr-loader-pulse"
        style={{ width: 72, height: 72, objectFit: "contain" }}
      />
    </Box>
  );
};

export default CenteredLoader;


